import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height:'50vh',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
}));

export default function CircularIndeterminate() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="text-center">
        <CircularProgress />
        <p><b>Loading ...</b></p>
      </div>
      {/* <CircularProgress color="secondary" /> */}
    </div>
  );
}
